const brandName = equipment =>
  typeof equipment?.brand === 'string' ? equipment.brand : equipment?.brand?.name;

export const getEquipmentLabel = equipment => {
  if (!equipment) return null;
  const parts = [equipment.model, brandName(equipment)].filter(Boolean);
  return parts.length ? parts.join(' - ') : null;
};

export const getEquipmentDescription = (equipment, equipmentId) => {
  if (!equipment) return '';
  const id = equipment.id ?? equipmentId;
  const label = getEquipmentLabel(equipment);
  if (!label) return id != null ? `ID: ${id}` : '';
  return id != null ? `ID: ${id} - ${label}` : label;
};
